import styled from 'styled-components'

export const Markdown = styled.div`
  white-space: normal;

  p,
  ul,
  ol {
    margin: 0;
  }

  * + p,
  * + ul,
  * + ol {
    margin-top: 8px;
  }

  ul,
  ol {
    padding-left: 20px;
  }

  code {
    font-family: monospace;
    font-size: 0.9em;
  }
`
